import { render, staticRenderFns } from "./HomePainSection.vue?vue&type=template&id=6ecc4394"
import script from "./HomePainSection.vue?vue&type=script&lang=js"
export * from "./HomePainSection.vue?vue&type=script&lang=js"
import style0 from "./HomePainSection.vue?vue&type=style&index=0&id=6ecc4394&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports